import PageLocker from './page-locker';

const pageLocker = new PageLocker();
export { PageLocker, pageLocker };
